<template>
  <div class="container-fluid notFound mb-5">
    <h1 class="notFound__title center-header mx-auto text-center">
      Stay Tuned!
    </h1>
    <p class="notFound__sentence">
      We are in the process of updating our coverage. We cover 190+ countries. If you receive this message it means that we are building a specific page for this country. You can request a quote through the contact page or with the usual way.
    </p>
    <div class="notFound__container">
      <div>
        <div class="flex-item">
          <a href="/coverage">
            <img
              class="notFound__img"
              src="/images/Q2BAOd2.png"
              alt="404"
            />
          </a>
        </div>
        <div class="flex-item mt-5">
          <a class="button" href="/">
            Go To Home
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'

useHead({
  title: '404 Coverage Not Found - inte-QT',
  meta: [
    {
      name: 'title',
      content: '404 Coverage Not Found - inte-QT',
    },
    {
      name: 'description',
      content:
        "If you are seeing this message it means that we don't have specific page for this country yet, you can go back to the home page or see our sitemap in the footer of this page.",
    },
  ],
})
</script>

<style scoped>
/* Optional: add your styles or import your CSS here */
</style>
